/**
 * The app version, inlined at build time from the repo-root VERSION file (see
 * `define` in vite.config.ts), so it always matches what the Go backend reports
 * at /version for the same release.
 */
export const APP_VERSION = __APP_VERSION__;

/** Renders the app version, for use in page footers. */
export function VersionTag({ className = "" }: { className?: string }) {
	return (
		<span className={className} title={`Solberegning versjon ${APP_VERSION}`}>
			v{APP_VERSION}
		</span>
	);
}
